import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import AuthLayout from "../../../components/layout/AuthLayout"
import FormInput from "../../../components/layout/FormInput"
import Button from "../../../components/ui/Button"

export default function SignUpPatient() {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState({
    firstName: "Nigel",
    lastName: "Farage",
    street: "Route du Général Crommant",
    number: "13",
    postalCode: "75000",
    city: "Paris",
    country: "France",
    assignedSite: "ULB - Hôpital Erasme", 
    assignedInvestigator: "Odile Deray",
  })
  const [errors, setErrors] = useState({})
  const [authError, setAuthError] = useState("")

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))


    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }))
    }


    if (authError) {
      setAuthError("")
    }
  }

  const validateForm = () => {
    const newErrors = {}

    // Required fields validation
    const requiredFields = ["firstName", "lastName", "street", "postalCode", "city", "country"]
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `This field is required`
      }
    })

    // Postal code validation - simple numeric check
    if (formData.postalCode && !/^\d+$/.test(formData.postalCode)) {
      newErrors.postalCode = "Postal code must contain only numbers"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  

  return (
    <AuthLayout
      title=""
      subtitle=""
      logoSrc="/img/logo.png"
      imageSrc="/img/Oshimed sign in image - earth.png"
      formWidth="half"
      contentPadding="small"
      maxWidth="full"
    >
      <div className="rounded-xl p-2 w-full">
        {/* Auth error message */}
        {authError && (
          <div className="mb-2 p-1 bg-red-100 border border-red-400 text-red-700 rounded-md">{authError}</div>
        )}

        <form className="space-y-2 w-full" >
          {/* First name and Last name */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormInput
              label="First name"
              id="firstName"
              name="firstName"
              type="text"
              placeholder="Nigel"
              value={formData.firstName}
              onChange={handleChange}
              error={errors.firstName}
              required
              disabled
            />
            <FormInput
              label="Last name"
              id="lastName"
              name="lastName"
              type="text"
              placeholder="Farage"
              value={formData.lastName}
              onChange={handleChange}
              error={errors.lastName}
              required
              disabled
            />
          </div>

          {/* Street and Number */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="md:col-span-3">
              <FormInput
                label="Patient address - Street"
                id="street"
                name="street"
                type="text"
                placeholder="Route du Général Crommart"
                value={formData.street}
                onChange={handleChange}
                error={errors.street}
                required
                disabled
              />
            </div>
            <FormInput
              label="Number"
              id="number"
              name="number"
              type="text"
              placeholder="13"
              value={formData.number}
              onChange={handleChange}
              error={errors.number}
              disabled
            />
          </div>

          {/* Postal code, City, Country */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <FormInput
              label="Postal code"
              id="postalCode"
              name="postalCode"
              type="text"
              placeholder="75000"
              value={formData.postalCode}
              onChange={handleChange}
              error={errors.postalCode}
              required
              disabled
            />
            <FormInput
              label="City / Town"
              id="city"
              name="city"
              type="text"
              placeholder="Paris"
              value={formData.city}
              onChange={handleChange}
              error={errors.city}
              required
              disabled
            />
            <FormInput
              label="Country"
              id="country"
              name="country"
              type="text"
              placeholder="France"
              value={formData.country}
              onChange={handleChange}
              error={errors.country}
              required
              disabled
            />
          </div>

          {/* Assigned site and Investigator */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <FormInput
              label="Assigned site"
              id="assignedSite"
              name="assignedSite"
              type="text"
              placeholder="ULB - Hôpital Erasme"
              value={formData.assignedSite}
              onChange={handleChange}
              error={errors.assignedSite}
              disabled
            />
            <FormInput
              label="Assigned investigator"
              id="assignedInvestigator"
              name="assignedInvestigator"
              type="text"
              placeholder="Odile Deray"
              value={formData.assignedInvestigator}
              onChange={handleChange}
              error={errors.assignedInvestigator}
              disabled
            />
          </div>

          {/* Continue button */}
          <div className="mt-6 flex justify-center">
            <Button type="submit" variant="login" className="" disabled={isLoading}>
              {isLoading ? "Processing..." : "Continue"}
            </Button>
          </div>

          {/* Terms and conditions */}
          <div className="mt-4 text-center">
            <p className="text-gray-600 text-sm">
              By creating an account, you agree to Oshimed's{" "}
              <Link to="/conditions-of-use" className="text-linkColor">
                Conditions of use
              </Link>
            </p>
          </div>
        </form>
      </div>
    </AuthLayout>
  )
}
